// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"293":"6faf1a4c","410":"e580fe99","453":"ed522fb1","516":"cc0dc1a7","917":"cf2971a8","946":"e35b9e46"}[chunkId] + ".chunk.js";
};